import { render, staticRenderFns } from "./сurrent-game.vue?vue&type=template&id=3ca5984b&scoped=true&"
import script from "./сurrent-game.vue?vue&type=script&lang=js&"
export * from "./сurrent-game.vue?vue&type=script&lang=js&"
import style0 from "./сurrent-game.vue?vue&type=style&index=0&id=3ca5984b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca5984b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ca5984b')) {
      api.createRecord('3ca5984b', component.options)
    } else {
      api.reload('3ca5984b', component.options)
    }
    module.hot.accept("./сurrent-game.vue?vue&type=template&id=3ca5984b&scoped=true&", function () {
      api.rerender('3ca5984b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chicken-road/сurrent-game.vue"
export default component.exports